import { Injectable } from '@angular/core';
// Import the required modules
import * as XLSX from 'xlsx';

interface ExcelDataItem {
  IDNumber: string;
  Name: string;
  Nationality: string;
  PassportNumber: string;
  SouthAfrica: string;
  Surname: string;
  TelephoneOfNextOfKin: string;
}

// Define the method in your service class
export class ImportService {
  // Method to import data from Excel file
  public importDataFromExcel(file: File): Promise<ExcelDataItem[]> {
    return new Promise((resolve, reject) => {
      try {
        const reader = new FileReader();

        reader.onload = (event: any) => {
          const data = new Uint8Array(event.target.result);
          const workbook = XLSX.read(data, { type: 'array' });
          const sheetName = workbook.SheetNames[0]; // Assuming data is on the first sheet

          const sheetData: ExcelDataItem[]  = XLSX.utils.sheet_to_json(workbook.Sheets[sheetName]);
          resolve(sheetData);
        };

        reader.onerror = (error) => {
          reject(error);
        };

        reader.readAsArrayBuffer(file);
      } catch (error) {
        reject(error);
      }
    });
  }
}
